import { render, staticRenderFns } from "./materialdetailspage.vue?vue&type=template&id=67a1d536&scoped=true&"
import script from "./materialdetailspage.vue?vue&type=script&lang=js&"
export * from "./materialdetailspage.vue?vue&type=script&lang=js&"
import style0 from "./materialdetailspage.vue?vue&type=style&index=0&id=67a1d536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1d536",
  null
  
)

export default component.exports